import toast from './../helpers/toast';

const state = {
    items: [],
    checkoutStatus: null,
    addBtn: false,
    updateDisc: false,
}

// getters
const getters = {
    cartProducts: (state, getters, rootState) => {
        // let items = [];

        return state.items.map(({id, quantity, files, product_id}) => {
            product_id = getPid(product_id)

            const product = JSON.parse(JSON.stringify(rootState.products.all.find(product => product.id === product_id)))
                product.count = (quantity > 1) ? quantity : 1;
                product.files = files;
                product.product_id =  product.id;
                product.id = id;
                return product;

        })
    },

    cartTotalPrice: (state, getters) => {

        return getters.cartProducts.reduce((total, product) => {
            if (product) {
                return total + product.price * product.count
            }
        }, 0)
    },

    cartTotalCount: (state, getters) => {
        return getters.cartProducts.reduce((total, product) => {
            if (product) {
                return total + product.count
            }
        }, 0)
    },
    addBtn: (state) => {
        return state.addBtn
    },
    updateDisc: (state) => {
        return state.updateDisc
    }
}

// actions
const actions = {

    addProductToCart({state, commit}, product) {
        commit('setCheckoutStatus', null)
        commit('addBtn', true)
        if (product.stock > 0) {
            let id = product.id;

            if (product.custom  && Number.isInteger(id)) {
                id = id + '_' + parseInt(Math.random() * 984573493);
            }

            const cartItem = state.items.find(item => item.id === id)

            if (!cartItem) {
                commit('pushProductToCart', {id, product})
            } else {
                commit('incrementItemQuantity', cartItem)
            }
            if (!product.custom) {
                commit('products/decrementProductInventory', {id: id, count: 1}, {root: true})
            }
            toast.success(window.drop_cart_updated)
        }
        commit('updateDisc', true)
        commit('saveCart')
    },
    addFilesToProduct({state, commit}, {product, files}) {
        const cartItem = state.items.find(item => item.id === product.id)
        commit('pushFileToProduct', {id: cartItem.id, files: files})
        commit('saveCart')
    },
    decrementItemQuantity({state, commit}, product) {
        const cartItem = state.items.find(item => item.id === product.id)
        if (cartItem) {
            commit('decrementItemQuantity', cartItem)
            if (!product.custom) {
                commit('products/incrementProductInventory', {id: product.id, count: 1}, {root: true})
            }
            toast.success(window.drop_cart_updated)
        }
        commit('updateDisc', true)
        commit('saveCart')
    },
    removeProductFromCart({state, commit}, product) {
        const cartItem = state.items.find(item => item.id === product.id)
        if (cartItem) {

            if (!product.custom) {
                commit('products/incrementProductInventory', {id: product.id, count: cartItem.quantity}, {root: true})
            }
            commit('removeProductFromCart', cartItem)
            toast.success(window.drop_cart_updated)
        }
        commit('updateDisc', true)
        commit('saveCart')
    },
    loadCart({commit}, cart) {
        commit('setCartItems', cart)
        commit('updateDisc', true)
    },
    cleanCart({commit}) {
        commit('cleanCart')
        commit('updateDisc', true)
    },
    saveCart({commit}) {
        commit('updateDisc', true)
        commit('saveCart')
    },
    updateDisc({commit}, status) {
        commit('updateDisc', status)
    }
}

// mutations
const mutations = {
    cleanCart(state) {
        state.items = [];
    },
    updateDisc(state, status) {
        state.updateDisc = status;
    },
    addBtn(state, val) {
        state.addBtn = val;
    },
    pushFileToProduct(state, {id, files}) {
        const cartItem = state.items.find(item => item.id === id)
        cartItem.files = files
    },
    pushProductToCart(state, {id, product}) {
        state.items.push({
            id: id,
            product_id: product.id,
            quantity: 1,
            files: [],
        })

    },

    removeProductFromCart(state, {id}) {
        state.items.forEach((item, i) => {
            if (item.id === id) {
                state.items.splice(i, 1);
            }
        })
    },
    incrementItemQuantity(state, {id}) {
        const cartItem = state.items.find(item => item.id === id)


        cartItem.quantity++
    },
    decrementItemQuantity(state, {id}) {

        const cartItem = state.items.find(item => item.id === id)


        cartItem.quantity--
    },

    setCartItems(state, items) {
        state.items = items
    },
    saveCart(state) {

        localStorage.setItem('cart_data', JSON.stringify(state.items))
    },

    setCheckoutStatus(state, status) {
        state.checkoutStatus = status
    }
}

const getPid = (id) => {
    if (!Number.isInteger(id) && id.includes('_')) {
        return parseInt(id.split('_')[0])
    }
    return id;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}